import { ReactElement } from "react";
import Create from "@shared/FormTemplates/Create";
import CreateForm from "./CreateForm";
import createItemAPI from "@services/Clients/WhaleShark/glance/createItem";
import validator from "@validators/Clients/WhaleShark/glance/Glance.validate";
import formMapper from "@mappers/Clients/WhaleShark/glance/glance.mapper";

const CreateItem = (): ReactElement => (
  <Create
    CustomForm={CreateForm}
    createHook={createItemAPI}
    validator={validator}
    formMapper={formMapper}
  />
);

export default CreateItem;
